<template>
  <div class="home">


<div class="works-ban">
		<h2>產品</h2>
		
		<div class="lib-sum">
		
			<div v-for="item in channel" :class="{'acts':channel_id==item.id}" @click="buff(item.id)">
			<div><h3>{{item.title}}</h3></div>
			<div>{{item.num}} 產品</div>
			</div>
			
		</div>
	
		
	</div>
   <div class="home-ct">
<el-row gutter="20">
	<el-col span="7">
		<div class="pro-chan">
			<div v-for="item in plus">
			<h3 :class="{'acts':channel_id==item.id}" @click="buff(item.id)">{{item.title}}</h3>
			<div v-for="it in item.channels">
				<div class="blu" @click="buff(it.id)"><div><img src="../../assets/cir.png"></div><span :class="{'acts':channel_id==it.id}">{{it.title}}</span></div>
				<div class="bls" v-for="is in it.channels" @click="buff(is.id)"><div><img src="../../assets/cir.png"></div><span :class="{'acts':channel_id==is.id}">{{is.title}}</span></div>
			</div>
			</div>
			
			
		
		</div>
		
		<div class="pro-chan2">
			<div>
			<h3 >產品</h3>
		
			</div>
			<div class="con">
			<ul>
				<li v-for="it in pros">
					    <router-link :to="'/product/details?id='+it.inventoryId">
					<el-row gutter="20">
						<el-col span="10">
							<img :src="it.img"  />
						</el-col>
						<el-col span="14" class="bule">
							<h6> {{it.title}}</h6>
							<p> CN ¥ {{it.price_sale}}</p>
						</el-col>
					</el-row>
					</router-link>		 
				</li>
				
			</ul>
			</div>
			
			
			
		
		</div>
		
		
	</el-col>
	<el-col span="17">
		<div class="home-arr">
				   
			   
			   	   <div class="con">
			   		   <ul>
						 
			   				   <li v-for="it in news">
								     <router-link :to="'/product/details?id='+it.inventoryId">
								  
								     <div class="skr">
										 
										   <el-tooltip class="item" effect="dark" content="選擇選項" placement="left" popper-class="draw_share_atooltip">
										   <div>  <img class="cart" @click.prevent="sandYart(it)" src="../../assets/cart.png" /></div>
										    </el-tooltip>
										 <el-tooltip class="item" effect="dark" content="快速查看" placement="left" popper-class="draw_share_atooltip">
									 <div>	<img class="cart" @click.prevent="finding(it)" src="../../assets/find.png" /></div>
										  </el-tooltip>
										   <el-tooltip class="item" effect="dark" content="添加到心願單" placement="left" popper-class="draw_share_atooltip">
										 <div><img class="cart" v-if="it.if_shoucang==0" @click.prevent="collect(it)" src="../../assets/like.png" /><img class="cart" v-else @click.prevent="collect(it)" src="../../assets/likes.png" /></div>
										  </el-tooltip>
									 </div>
								
							
								   
								   <img class="fit" v-if="it.kucun==0" src="../../assets/sold_out.png" />
								   <div class="pic">
									   <img :src="it.img" />
								   </div>
								   <div class="txt">
									   <p>
		{{it.title}}</p>
								 
		 <p class="time">
		CN ¥ {{it.price_sale}} </p>
		 
								   </div>
			   					 </router-link>		  
			   				   </li>
						
																			
			   				 
			   			   </ul>
						 
			   	   </div>
			   </div>
	</el-col>
</el-row>

	  
	   
	   
	   <div class="page">
	     
	     <el-pagination
	       layout="prev, pager, next"
	       :total="total"
		   @current-change="pick">
	     </el-pagination>
	   </div>
	   

   </div>
  
 
 <div v-if="cart">
 		   <div class="brand" ></div>
 <div class="carts">
 		<div class="cart-tit">
 			<h4>購物車</h4>
 			<div class="cr" @click="cart=false">CLOSE<img src="../../assets/arr.png"  /></div>
 			
 					</div>
 					<div class="cart-con">
 						<ul>
 							<li v-for="item in roll">
 								<div class="lt">
 								<div class="pic">
 									<img :src="item.image" />
 								</div>
 								<div class="txt">
 									<p><b>{{item.title}}</b></p><p>{{item.num}}× <b>CN ¥ {{item.price_sale}}</b></p>
 								</div>
 								</div>
 								<div class="clo" @click="bit(item)">
 									<img src="../../assets/arr.png" />
 								</div>
 							</li>
 						
 					</ul>
 					</div>
 					
 					<div class="cart-bot">
 						<div class="l1">
 							<h4>小計:</h4>
 							<h4>CN ¥{{price}}</h4>
 						</div>
 						<div class="l2">
 							<router-link to="/product/cart"><div class="h-button cart-but">查看購物車</div></router-link>
 							<router-link to="/product/order"><div class="h-button cart-but">結帳</div></router-link>
 						</div>
 					</div>
 		   
 </div></div>
 
 <el-dialog
:visible.sync="dialogVisible"
   width="1200px"
  :before-close="handleClose"
>
 <div class="product-st">
 	 
 			   <div class="pic">
 				  <div class="l1">
 					
 					 <div class="block">
 						<img :src="proImg" />
 					   </div>
 				  </div>
 			
 			   </div>
 			    <div class="txt">
 					<h2>{{pro.title}}</h2>
 					<div class="l3" v-if="pro.kucun==0"><img src="../../assets/stock.png"></div>
 					<div class="l4">
 						CN ¥ {{pro.price_sale}}
 						<span></span>
 					</div>
 					<div class="l5">
 						 <el-input-number size="mini"  v-model="num"  :min="1" :max="pro.kucun" ></el-input-number>
 						 <div class="cart-but" @click="sandYart(pro)">添加到購物車</div>
 					</div>
 					<div class="wishlist">
 					
 						<div class="co2">
 							分享 ：
 														<a href="https://www.facebook.com/sharer.php?u=http://cn.fmhd.209.qiyundongli.cn/" title="facebook" target="_blank">	<img src="../../assets/facebook.png" /></a>
 															
 														<a href="http://twitter.com/share?text=FuelMe&url=http://cn.fmhd.209.qiyundongli.cn/" title="twitter" target="_blank"><img src="../../assets/twitter.png" /></a>
 							<a href="http://service.weibo.com/share/share.php?url=http://cn.fmhd.209.qiyundongli.cn/&title=FuelMe" title="weibo" target="_blank"><img src="../../assets/weibo.png" /></a>
 							
 						</div>
 					
 					</div>
 				</div>
 </div>
 </el-dialog>

  </div>
</template>
<script>


export default {

  data() {
    return {
		key:'',
		pros:'',
		num: 1,
		dialogVisible: false,
		info:'',
		news:[],
		notice:[],
		total:'',
		id:'',
		pro:'',
		proImg:'',
		page:1,
		cart:false,
		roll:'',
		channel_id:0,
		hans:'',
		channel:'',
		plus:''
		
	
		
    
    };
  }, watch: {
    '$route' (to, from) {
		this.key= this.$route.query.key;
		this.sandMate()
	
    
    }
},  mounted() {
	  this.key = this.$route.query.key;  
 this.channel_id = this.$route.query.id;
		this.sandMate();
		this.sandPro()
		this.sandHans();
		this.sandChan();
		this.sandCase();
		this.sandCart();
		
		
		},methods: {
			finding(it){
				
				this.proImg=it.img
				this.id=it.inventoryId
				this.dialogVisible=true
				this.sandCase()
			
			},
		
			
		sandCase(){
		
			this.$axios({
			  method: "post",
			  url: "service.php?action=product_detail",
			  data: {inventoryId:this.id},  
			}).then((res) => {
				let data=res.data;
			
				if(data.code==1){
					this.pro=data.data;
				}
			 
			});
		
		}, buff(item){
				this.channel_id=item
				this.page=1
				this.sandMate()
			},handleClose(done) {
			this.num=1
			done();
       
      },sandYart(it){
		  this.id=it.inventoryId
				if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
					  this.$router.push({ path: "/login" });	
					return
				}
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_add",
				  data: {inventoryId:this.id,num:this.num},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
					this.cart=true;
					this.sandCart()
					
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},sandCart(){
				this.price=0;
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_lists",
				  data: {},  
				}).then((res) => {
					let data=res.data;
					
					
					if(data.code==1){
						this.roll=data.data;
						
						this.roll.forEach((item, index) => {
						
						
							this.price =this.price+item.price_sale * item.num
							
						})
						this.price=this.price.toFixed(2)
					}
				 
				});
			},bit(item){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=gouwuche_del",
				  data: {inventoryId:item.inventoryId},  
				}).then((res) => {
					let data=res.data;
					
					if(data.code==1){
						this.$message.success(data.message);
						
						this.sandCart()
					}else{
						this.$message.error(data.message);
					}
				 
				});
			},
			collect(it){
				this.id=it.inventoryId
							if(window.localStorage.getItem('user')== "undefined"||!window.localStorage.hasOwnProperty('user')){
								  this.$router.push({ path: "/login" });	
								return
							}
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_collect",
							  data: {inventoryId:this.id,collect_type:0},  
							}).then((res) => {
								let data=res.data;
								
								if(data.code==1){
									this.$message.success(data.message);
								this.sandMate()
								
								}else{
									this.$message.error(data.message);
								}
							 
							});
						},
						pick(item){
							this.page=item;
							this.sandMate()
							document.documentElement.scrollTop = 0;
						},
						sandPro(){
					
							this.$axios({
							  method: "post",
							  url: "service.php?action=product_plist",
							  data: {pagenum:5},  
							}).then((res) => {
								let data=res.data;
						
								if(data.code==1){
							this.pros=data.data;
								
									
								}
							 
							});
						
						},
			sandMate(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_plist",
				  data: {page:this.page,channel_id:this.channel_id,keyword:this.key},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
							this.news=data.data;
												this.total=data.count
						
						
						
					}
				 
				});
			
			},sandHans(){
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_plist",
				  data: {is_index:1},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.hans=data.data;
						
						
					}
				 
				});
			
			},sandChan(){
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_channelData",
				  data: {},  
				}).then((res) => {
					let data=res.data;
							
					if(data.code==1){
				
										
						this.channel=data.data;
						
						
					}
				 
				});
				
				
				this.$axios({
				  method: "post",
				  url: "service.php?action=product_channel",
				  data: {},  
				}).then((res) => {
					let data=res.data;
			
					if(data.code==1){
				
										
						this.plus=data.data;
						
						
					}
				 
				});
			
			}
		}
};
</script>
<style lang="scss" scoped>

	 .el-carousel__item h3 {
	    color: #475669;
	    font-size: 18px;
	    opacity: 0.75;
	    line-height: 300px;
	    margin: 0;
	  }
	  
	  .el-carousel__item:nth-child(2n) {
	    background-color: #99a9bf;
	  }
	  
	  .el-carousel__item:nth-child(2n+1) {
	    background-color: #d3dce6;
	  }
.home{
	
	.works-ban{
		padding-top: 30px;
		background: #0A0A0A;
		height: 157px;
		color: #FFFFFF;
		text-align: center;
		line-height: 40px;
		.lib-sum{
			font-size: 14px;
			width:1000px;
			margin: 20px auto;
			display: flex;
			justify-content: space-between;
			text-align: left;
			line-height: 25px;
			color: #C7C7C7;
			cursor: pointer;
			h3{
				color: #FFFFFF;
				font-size: 16px;
			}
		}
		h2{
			font-size: 43px;
		}
	
		.acts{
			color: #FFFFFF;
		
		}
	}
	.home-ct{
		width: 1200px;
		margin: 0 auto;
	}
	.pro-chan{
		padding: 20px 10px;
		line-height: 40px;
		font-size: 14px;
		cursor: pointer;
		.acts{
			color: #b70000;
		}
		h3{
			font-size: 16px;
		}
		.blu{
			display: flex;
			flex-direction: row;
			align-items: center;
			color: #636363;
		}
		.bls{
			display: flex;
			flex-direction: row;
			color: #636363;
			img{
				margin-left: 15px;
			}
		}
		img{
			width: 5px;
			height: 5px;
			margin-right: 10px;
		}
	}
	.pro-chan2{
		border-top: 1px solid #A2A2A2;
		padding: 20px 10px;
		line-height: 40px;
		font-size: 14px;
		.con{
			li{
				margin-bottom: 20px;
				border-bottom: 1px solid #EEEEEE;
				font-size: 14px;
				
				img{
					width: 100%;
				}
				h6{
					font-size: 14px;
					line-height: 20px;
				}
				h6:hover{
					color: #666;
				}
				.bule{
					color: #333;
				}
				
			
			}
		}
		
	}
	.banner{
		width: 100%;
		height: 709px;
		background: url(../../assets/banner1.png);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		
	}
	.tit{
		display: flex;
		justify-content: space-between;
		align-items: center;
		h4{
			font-size: 24px;
			font-weight: normal;
		}
	
	}
	.all{
		text-align: center;
		margin: 30px;
	}
	.banner2{
		width: 100%;
		height: 590px;
		background: url(../../assets/banner2.png) center center;
	
	}
	.h-banner{
		position: relative;
		
		.h-banner-t{
			width: 100%;
			text-align: center;
			position: absolute;
			top: 200px;
			z-index: 999;
			.ban-but{
				width: 190px;
				height: 48px;
				background: url(../../assets/but.png);
				background-size: 100%;
				text-align: center;
				line-height: 48px;
				margin-top: 20px;
				margin: 50px auto;
			}
			.ban-but:hover{
				background: url(../../assets/but2.png);
				background-size: 100%;
			}
		}
	}
	.skr{
		display:none;
		flex-direction: column;
		position: absolute;
		top: 20px;
		right: 20px;
		color: #FFFFFF;
		z-index: 999;
		width: 61px;
		height: 145px;
		justify-content: space-evenly;
		align-content: center;
		text-align: center;
		background: url(../../assets/menu1.png);
			.cart{
				width: 20px;
				margin: 0 auto;
			}
		
		
	}
	.home-show{
		margin-top: 30px;
		.con{
			margin: 50px 0;
			ul{
				
				li{
					width: 400px;
					float: left;
					position: relative;
				
					p{
						img{
							margin-left: 30px;
						}
					}
					.time{
						color: #999999;
						margin-top: 30px;
					}
				}
				
			
				
			}
		
		}
		
	}

	.home-arr{
		.con{

			ul{
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;
				li{
					position: relative;
					width: 589px;
					height:400px;
					border: 1px solid #EEEEEE;
					width: 49%;
					margin-top: 40px;
					
					.pic{
						width: 100%;
						height: 293px;
						overflow: hidden;
						img{
							width: 100%;
							height: 293px;
							transition: all 0.5s;
						}
						img:hover{
							 transform: scale(1.2);
						}
						
					
					}
					.txt{
						padding: 15px;
						line-height: 25px;
						p{
							height: 50px;
							overflow: hidden;
						}
						.time{
							color: #494949;
						}
					}
					.fit{
						position: absolute;
						top: -11px;
						left: 30px;
						z-index: 800;
					}
				}
				li:hover{
					.skr{
						display:flex;
					}
				}
			
			}
		}
	}
	.page{
		text-align: center;
		margin:50px auto;
	}
	.product-st{

		display: flex;
	
		.item-acticve{
			background: #333333;
		}
		.pic{
			width: 613px;
			.l1{
				img{
					width: 613px;
					height: 410px;
				}
				
			}
			
		}
		.txt{
			flex: 1;
			padding: 20px 40px;
			.l3{
				margin: 20px 0;
				img{
					width: 141px;
					height: 36px;
					
				}
			}
			.l4{
				color: #2D2A2A;
				font-size: 24px;
				span{
					color: #7C7C7C;
					font-size: 20px;
					margin-left:10px;
				
				}
			}
			.l5{
				display: flex;
				margin-top: 20px;
				.cart-but{
					font-size: 14px;
					width: 131px;
					height:38px;
					line-height: 38px;
					background-color: #FB2C00;
					color: #FFFFFF;
					text-align: center;
					margin-left: 20px;
				}
			}
			.wishlist{
				border-top: 1px solid #dedede;
				margin-top: 100px;
				padding-top: 30px;
				color: #2D2A2A;
				font-weight: bolder;
				img{
					height: 20px;
					margin-right: 10px;
				}
				.co1{
					display: flex;
					margin-bottom: 20px;
				}
				.co2{
					display: flex;
				}
				
			}
		}
	}
}

</style>